module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-right-dots-fill-adcad9b1.svg";